// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The white card the public forms sit in (Request support, Busy Bees
   sign-up), with its checkbox chips and result messages. */
.form-card {
  background-color: var(--surface-raised);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-soft);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-card fieldset {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: none;
  margin: 0;
  padding: 0;
  font-weight: 600;
  color: var(--text-primary);
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  /* Every row as tall as the tallest, so a chip whose label wraps doesn't
     leave the others looking uneven. */
  grid-auto-rows: 1fr;
  gap: 12px;
  margin-top: 4px;
  container-type: inline-size;
}

/* Once the grid has two or more columns (2 x 160px + gap), give every chip
   room for a two-line label, so grids with and without a wrapping label
   (Busy Bees vs. Request support) come out the same size. A single stacked
   column keeps one-line chips. */
@container (min-width: 332px) {
  .check-option {
    min-height: calc(2lh + 24px);
  }
}

/* The whole chip is a <label>, so clicking anywhere in it toggles the box. */
.check-option {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: var(--surface-sunken);
  border-radius: 10px;
  padding: 12px 12px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
}

.check-option input {
  /* Fixed size even when the label beside it wraps. */
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  accent-color: var(--text-accent);
  cursor: pointer;
}

.form-success {
  margin: 0;
  color: var(--text-primary);
  font-weight: 600;
}

.form-error {
  margin: 0;
  color: var(--text-accent);
  font-weight: 600;
}

/* Underlined so the fallback address reads as a link — links elsewhere are
   distinguished by color, which does nothing inside already-accent-colored
   error text. */
.form-error a,
.form-error a:visited {
  color: inherit;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/FormCard.css"],"names":[],"mappings":"AAAA;2DAC2D;AAC3D;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D;uCACqC;EACrC,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;;iCAGiC;AACjC;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;gBAEgB;AAChB;;EAEE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":["/* The white card the public forms sit in (Request support, Busy Bees\n   sign-up), with its checkbox chips and result messages. */\n.form-card {\n  background-color: var(--surface-raised);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-soft);\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.form-card fieldset {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: none;\n  margin: 0;\n  padding: 0;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.checkbox-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  /* Every row as tall as the tallest, so a chip whose label wraps doesn't\n     leave the others looking uneven. */\n  grid-auto-rows: 1fr;\n  gap: 12px;\n  margin-top: 4px;\n  container-type: inline-size;\n}\n\n/* Once the grid has two or more columns (2 x 160px + gap), give every chip\n   room for a two-line label, so grids with and without a wrapping label\n   (Busy Bees vs. Request support) come out the same size. A single stacked\n   column keeps one-line chips. */\n@container (min-width: 332px) {\n  .check-option {\n    min-height: calc(2lh + 24px);\n  }\n}\n\n/* The whole chip is a <label>, so clicking anywhere in it toggles the box. */\n.check-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: var(--surface-sunken);\n  border-radius: 10px;\n  padding: 12px 12px;\n  font-weight: 500;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.check-option input {\n  /* Fixed size even when the label beside it wraps. */\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  accent-color: var(--text-accent);\n  cursor: pointer;\n}\n\n.form-success {\n  margin: 0;\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.form-error {\n  margin: 0;\n  color: var(--text-accent);\n  font-weight: 600;\n}\n\n/* Underlined so the fallback address reads as a link — links elsewhere are\n   distinguished by color, which does nothing inside already-accent-colored\n   error text. */\n.form-error a,\n.form-error a:visited {\n  color: inherit;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
